import type { OpsFilters } from "../opsDashboard.types";

/** Both endpoints take the same filter contract, so it is serialised in one place. */
export function applyFilters(url: URL, filters: OpsFilters) {
    url.searchParams.set("tab", filters.tab);
    filters.opsOwnerIds.forEach((id) => url.searchParams.append("ops_owner_id", String(id)));
    filters.organizationIds.forEach((id) => url.searchParams.append("organization_id", String(id)));
    filters.csmIds.forEach((id) => url.searchParams.append("csm_id", String(id)));
    filters.contractIds.forEach((id) => url.searchParams.append("contract_id", String(id)));
    // Sent only on the tab that owns them, so a window chosen on Onboarding cannot
    // silently narrow the Live tab when the user switches back.
    if (filters.tab === "onboarding" && filters.startWindow) {
        url.searchParams.set("start_window", filters.startWindow);
    }
    if (filters.tab === "ended" && filters.endWindow) {
        url.searchParams.set("end_window", filters.endWindow);
    }
}
